import { FC, useMemo } from 'react';

import { type ActivityMember, type ActivityPeriod, activityPeriod } from '@/api/gamma-team/types';
import { DatePicker, type DateRange, Select } from '@/design-system';

import { PERIOD_OPTIONS } from './period';
import { FilterBar, FilterSlot, ManagerSlot, RangeSlot } from './styled';
import { TeamMemberPicker } from './team-member-picker';

interface TeamActivityFiltersProps {
  period: ActivityPeriod;
  from: Date | null;
  to: Date | null;
  members: readonly string[] | null;
  canViewTeam: boolean;
  options: ActivityMember[];
  currentMember: ActivityMember | null;
  onPeriodChange: (_period: ActivityPeriod) => void;
  onRangeChange: (_range: DateRange) => void;
  onMembersChange: (_members: string[]) => void;
}

export const TeamActivityFilters: FC<TeamActivityFiltersProps> = ({
  period,
  from,
  to,
  members,
  canViewTeam,
  options,
  currentMember,
  onPeriodChange,
  onRangeChange,
  onMembersChange,
}) => {
  const today = useMemo(() => new Date(), []);

  return (
    <FilterBar>
      <FilterSlot>
        <Select
          size="lg"
          ariaLabel="Period"
          placeholder="Period"
          value={period}
          options={PERIOD_OPTIONS}
          onChange={(value) => onPeriodChange(value as ActivityPeriod)}
        />
      </FilterSlot>

      {period === activityPeriod.Custom && (
        <RangeSlot>
          <DatePicker
            months="range"
            fullWidth
            placeholder="Select dates"
            maxDate={today}
            value={{ from, to }}
            onChange={onRangeChange}
          />
        </RangeSlot>
      )}

      <ManagerSlot>
        <TeamMemberPicker
          selected={members}
          options={options}
          currentMember={currentMember}
          disabled={!canViewTeam}
          onChange={onMembersChange}
        />
      </ManagerSlot>
    </FilterBar>
  );
};
